<template>
  <SectionTemplate
    class="user-review-section"
    title="用户评价"
    :desc="'被百万用户选择的PPT创作升级AI工具'"
  >
    <div class="carousel-list">
      <CommonCarousel :items="reviewList1">
        <template #item="{ item, index }">
          <ReviewCard v-bind="item" :key="index" />
        </template>
      </CommonCarousel>
      <CommonCarousel :items="reviewList2" direction="right">
        <template #item="{ item, index }">
          <ReviewCard v-bind="item" :key="index" />
        </template>
      </CommonCarousel>
    </div>
    <ArrowBtn
      variant="black-common"
      class="user-review-section__btn"
      text="免费试用"
      @click="$emit('trail')"
    />
  </SectionTemplate>
</template>

<script setup lang="ts">
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';
import CommonCarousel from '@/design/components/common-carousel/index.vue';
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import type { ReviewCardProps } from '../../components/ReviewCard.vue';
import ReviewCard from '../../components/ReviewCard.vue';

const reviewList1 = ref<ReviewCardProps[]>([
  {
    avatar: 1,
    username: '张**',
    userRole: '某连锁餐饮企业培训负责人',
    content:
      '以前做入职培训PPT，从找资料到排版，折腾两三天是常事。现在有言输入“食品安全标准”几个字，几分钟就出一版PPT，连讲稿都配好了，直接改改就能用，做成视频还能让员工更容易理解。',
    rating: 5,
  },
  {
    avatar: 2,
    username: '李**',
    userRole: '某科技公司市场专员',
    content:
      '我们产品要推海外，找翻译做英文PPT又贵又慢。有言直接输入中文，一键生成英文版，连演讲稿都翻译好了。配合数字人视频生成功能，半天能做出三条不同语言的视频。',
    rating: 5,
  },
  {
    avatar: 3,
    username: '王**',
    userRole: '高校老师',
    content:
      '备课做PPT要经常调格式，很浪费时间。我现在用有言输入课程大纲，自动生成结构清楚的课件。再用有言PPT升级工具，生成视频和智能体之后，学生的学习效率也比单纯看PPT和书本效率更高。',
    rating: 4.5,
  },
  {
    avatar: 4,
    username: '陈**',
    userRole: '某建筑公司投标专员',
    content:
      '投标经常是头天下标书，第二天就要讲标。以前通宵做PPT是常态。现在把标书关键点贴进去，AI直接生成逻辑清晰的演示文稿，排版专业，导出PDF就能打印，再也不用为格式熬通宵了。',
    rating: 5,
  },
  {
    avatar: 5,
    username: '苏**',
    userRole: '深圳跨境大卖运营',
    content:
      '做欧美市场的产品PPT，最头疼风格不对路。有言那些国际范模板很对我胃口，生成的内容老外看了也说专业。最爽的是讲稿直接配好，拿来就能用，不用自己憋英文。',
    rating: 5,
  },
  {
    avatar: 6,
    username: '吴**',
    userRole: '互联网公司产品经理',
    content:
      'PM都懂，写PRD不难，难的是给老板汇报的PPT。有言同步生成讲稿这个功能太懂我了！输入几个核心功能，不仅PPT有了，连汇报词都帮我写好，不用对着屏幕发呆想怎么讲了。',
    rating: 5,
  },
  {
    avatar: 7,
    username: '小**',
    userRole: 'B站医学科普UP主',
    content:
      '做一期科普视频，写脚本加做PPT，两天就没了。有言输入选题，直接给我整出图文并茂的课件，讲稿通俗易懂，稍微改改就能录视频。而且还能使用自己的IP形象批量做视频，非常高效。',
    rating: 4.5,
  },
  {
    avatar: 8,
    username: '刘**',
    userRole: '外企行政主管',
    content:
      '年会、季度会、员工活动，各种PPT做到手软。以前求设计部门排期得等一周。现在自己动手，输入主题选个模板，几分钟搞定，颜色还能调成我们公司的VI。',
    rating: 5,
  },
  {
    avatar: 9,
    username: '林**',
    userRole: 'AI初创公司CEO',
    content:
      '融资季一周见了七八个投资人，PPT改了无数版。有言帮我大忙，输入想法直接生成路演PPT，每页还配上讲解词。并且使用有言PPT生成智能体功能，让投资人能直接了解公司信息，更有科技感。',
    rating: 5,
  },
]);

const reviewList2 = ref<ReviewCardProps[]>([
  {
    avatar: 1,
    username: '赵**',
    userRole: '某建筑设计公司设计总监',
    content:
      '方案汇报前总要熬几个通宵做PPT。现在把设计理念和关键词输进去，AI自动生成逻辑清晰的工作室风格PPT，排版高级，还能配示意图，拿给甲方看很有面子。',
    rating: 5,
  },
  {
    avatar: 2,
    username: '孙**',
    userRole: '某人力资源公司招聘经理',
    content:
      '校招季要做几十场宣讲会PPT，每个学校还得微调。有言输入岗位要求和公司介绍，几分钟生成不同版本，排版统一又专业，再不用重复做图调格式了。',
    rating: 5,
  },
  {
    avatar: 3,
    username: '黄**',
    userRole: '律师事务所合伙人',
    content:
      '给客户讲案子，PPT要专业还得快。有言把案件要点输进去，AI生成结构严谨的法律风格演示文稿，法条引用准确，客户一看就清楚，省了助理不少时间。',
    rating: 5,
  },
  {
    avatar: 4,
    username: '唐**',
    userRole: '某保险公司培训讲师',
    content:
      '新产品上线，全国代理人等着培训材料。有言输入产品卖点，AI自动生成标准化课件和讲稿，各地分公司直接拿去用，培训质量终于统一了。',
    rating: 5,
  },
  {
    avatar: 5,
    username: '朱**',
    userRole: '留学机构文案主管',
    content:
      '给学生做院校宣讲会PPT，每个学校情况不一样。有言输入学校名称和特色，AI生成中英双语版本，排版漂亮，家长学生都说讲得清楚。',
    rating: 5,
  },
  {
    avatar: 6,
    username: '沈**',
    userRole: '房地产公司策划经理',
    content:
      '项目开盘前要做各种汇报PPT。有言输入楼盘卖点和客群，AI生成专业的营销演示文稿，连讲稿都配好了，给领导汇报一次过。',
    rating: 5,
  },
  {
    avatar: 7,
    username: '顾**',
    userRole: '出版社策划编辑',
    content:
      '新书发布会PPT，以前找设计排期得两周。现在有言输入书稿亮点，几分钟生成文艺风格的演示文稿，作者看了非常满意。',
    rating: 5,
  },
  {
    avatar: 8,
    username: '乔**',
    userRole: '咨询公司顾问',
    content:
      '给客户做方案，PPT就是门面。有言输入分析框架和结论，AI生成专业咨询风格的演示文稿，图表排版规范，客户直接拿去给老板汇报。',
    rating: 5,
  },
  {
    avatar: 9,
    username: '龚**',
    userRole: '电商平台运营',
    content:
      '双11大促要做几十个品类招商PPT。有言输入品类关键词，批量生成风格统一的演示文稿，每个都配好讲解词，招商效率翻倍。',
    rating: 5,
  },
  {
    avatar: 10,
    username: '严**',
    userRole: '幼儿园老师',
    content:
      '家长会、开放日要做各种PPT。有言输入活动主题，生成卡通风格的课件，配图可爱，家长们拍照发朋友圈，都说幼儿园用心。',
    rating: 5,
  },
  {
    avatar: 1,
    username: '欧阳**',
    userRole: '留学归国创业人员',
    content:
      '回国融资路演，英文PPT转中文头疼。有言上传英文版，一键生成中文PPT和讲稿，术语翻译准确，投资人看得明白。',
    rating: 5,
  },
  {
    avatar: 2,
    username: '许**',
    userRole: '美术馆策展人',
    content:
      '展览导览PPT要兼顾艺术感和信息量。有言输入展览主题和作品信息，生成艺术风格的演示文稿，观众跟着导览看展，体验特别好。',
    rating: 5,
  },
  {
    avatar: 3,
    username: '何**',
    userRole: '心理咨询工作室主理人',
    content:
      '做心理科普讲座，PPT要温和有温度。有言输入主题，生成柔和色调的课件，讲稿也写得温暖专业，听众反馈很容易理解。',
    rating: 5,
  },
]);
</script>

<style lang="scss" scoped>
.user-review-section {
  background-color: var(--x-back-3);
  :deep(.section-content) {
    padding-left: 0;
    padding-right: 0;
    width: 100%;
  }
}
.carousel-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}
.user-review-section__btn {
  margin-top: 80px;
}
</style>
